export default __webpack_public_path__ + "static/media/sticker-c.91d562be.png";